export default __webpack_public_path__ + "static/sc-printed-2c493ce7e51a626680a5fe1c05a9563b.webp";